export default __webpack_public_path__ + "static/media/15.54370b63.jpg";